export default __webpack_public_path__ + "static/media/52.0fc686bf.png";